// 红色主题资源路径
const redAssets = {
  loadingAnima: require('../assets/loading.webp'),
  logo: require('../assets/images/logo.png'),
  logoHk: require('../assets/images/logo_hk.png')
}

// 红色主题资源路径
const blueAssets = {
  loadingAnima: require('../assets/theme-blue/loading.webp'),
  logo: require('../assets/theme-blue/images/logo.webp'),
  logoHk: require('../assets/theme-blue/images/logo_hk.webp')
}

const themeAssets = {
  red: redAssets,
  blue: blueAssets
}

export default themeAssets
